import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import ContactForm from '@/components/ContactForm';

const contactItems = [
  {
    icon: MapPin,
    title: 'Location',
    lines: ['Unit 2, 1 Doric Way, Islington', 'Christchurch, New Zealand'],
  },
  {
    icon: Phone,
    title: 'Phone',
    lines: ['022 657 8662'],
    href: 'tel:+64226578662',
  },
  {
    icon: Mail,
    title: 'Email',
    lines: ['info@precisionvapour.co.nz'],
  },
];

const ContactSection = () => {
  return (
    <section id="contact" className="section-padding bg-background relative">
      <div className="container-wide mx-auto">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '0.2s' }}>
            <p className="text-primary font-medium tracking-[0.3em] uppercase mb-4 text-sm">
              Contact
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Get in <span className="gradient-text">Touch</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-10">
              Ready to experience the future of surface restoration? Contact us today for a
              consultation or quote.
            </p>

            <div className="space-y-6">
              {contactItems.map(({ icon: Icon, title, lines }) => (
                <div key={title} className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
                    <Icon className="text-primary w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-lg text-foreground mb-1">{title}</h3>
                    {lines.map((line) => (
                      <p key={line} className="text-muted-foreground">
                        {line}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
